import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Checkbox, FormControlLabel, Link, Typography } from '@mui/material';

interface TermsConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Close the surrounding sign-up dialog so the policy page is actually visible. */
  onNavigate?: () => void;
}

/**
 * Play's UGC policy: users accept the terms before they can post. The server
 * rejects a signup without it, so this checkbox is not the only guard.
 *
 * In-app router links rather than target="_blank": inside the native WebView a
 * new-window link to a relative URL has nowhere to go.
 */
const TermsConsent: FC<TermsConsentProps> = ({ checked, onChange, onNavigate }) => (
  <FormControlLabel
    sx={{ alignItems: 'flex-start', mx: 0, my: 1 }}
    control={
      <Checkbox size="small" checked={checked} onChange={(e) => onChange(e.target.checked)} sx={{ pt: 0.25 }} />
    }
    label={
      <Typography variant="body2" color="text.secondary">
        I agree to the{' '}
        <Link component={RouterLink} to="/policies" onClick={onNavigate}>
          Terms
        </Link>{' '}
        and{' '}
        <Link component={RouterLink} to="/policies/privacy" onClick={onNavigate}>
          Privacy Policy
        </Link>
      </Typography>
    }
  />
);

export default TermsConsent;
